/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: {
    feature: { type: 'variant', values: [ true ] },
    inverse: { type: 'variant', values: [ true ] },
    label: { type: 'variant', values: [ true ] },
    large: { type: 'variant', values: [ true ] },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs' ] },
      tokens: {
        containerPaddingBottomTop: 16,
        containerPaddingLeftRight: 24,
        labelFontSize: 14,
        labelLineHeight: 1.42857142857,
        textLineHeight: 1.42857142857
      }
    },
    {
      if: { large: true },
      tokens: {
        textFontSize: 64,
        textLineHeight: 1.125,
        textTimerFontName: 'HelveticaNow',
        textTimerFontWeight: '300'
      }
    },
    {
      if: { feature: true },
      tokens: {
        labelBorderColor: '#4b286d',
        textFontSize: 64,
        textLineHeight: 1.125,
        textTimerFontName: 'HelveticaNow',
        textTimerFontWeight: '300'
      }
    },
    {
      if: { large: true, viewport: [ 'xs' ] },
      tokens: { textFontSize: 40 }
    },
    {
      if: { feature: true, viewport: [ 'xs' ] },
      tokens: { textFontSize: 40 }
    },
    { if: { inverse: true }, tokens: { labelBorderColor: '#ffffff' } },
    {
      if: { feature: true, inverse: true },
      tokens: { containerBorderColor: '#676e73', labelBorderColor: '#ffffff' }
    }
  ],
  tokens: {
    containerBorderColor: 'rgba(0, 0, 0, 0)',
    containerBorderRadius: 6,
    containerBorderWidth: 2,
    containerGradient: {
      angle: 135,
      stops: [ { color: '#4b286d', stop: 0 }, { color: '#e53293', stop: 1 } ],
      type: 'linear'
    },
    containerInverseBorder: 2,
    containerInverseBorderColor: '#ffffff',
    containerPaddingBottomTop: 48,
    containerPaddingLeftRight: 64,
    inverseBorderColor: '#676e73',
    labelBorderColor: '#414547',
    labelFontName: 'HelveticaNow',
    labelFontSize: 16,
    labelFontWeight: '400',
    labelLineHeight: 1.5,
    textFontSize: 16,
    textLineHeight: 1.5,
    textTimerFontName: 'HelveticaNow',
    textTimerFontWeight: '400'
  }
}
export default theme
